import React from 'react';
import { PencilSquare } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from './shared/PrimaryButton';
import OutlinePrimaryButton from './shared/OutlinePrimaryButton';
import { useMaxWidth } from '../hooks/useIsMobile';
import { DASHBOARD_ROUTES } from '../constants/dashboardRoutes';

/** Viewport at or below this width moves Journal + Trading Rules into the sidebar (trade page). */
export const NARROW_TRADE_HEADER_MAX_WIDTH = 1024;

export function useNarrowTradeHeader() {
  return useMaxWidth(NARROW_TRADE_HEADER_MAX_WIDTH);
}

/**
 * Journal + Trading Rules controls for app shell headers and narrow trade sidebar.
 */
export default function TradeJournalLockoutActions({ variant = 'header', panelColors }) {
  const navigate = useNavigate();

  const openTradingRules = () => navigate(DASHBOARD_ROUTES.tradingRules);
  const openJournal = () => window.dispatchEvent(new Event('tradeJournal:open'));

  const rulesButton =
    variant === 'sidebar' ? (
      <OutlinePrimaryButton
        size="sm"
        onClick={openTradingRules}
        style={{ width: '100%', borderRadius: 8 }}
        aria-label="Trading Rules"
      >
        Trading Rules
      </OutlinePrimaryButton>
    ) : (
      <OutlinePrimaryButton
        size="sm"
        onClick={openTradingRules}
        style={{ height: 32, minHeight: 32, padding: '0 14px' }}
        aria-label="Trading Rules"
      >
        Trading Rules
      </OutlinePrimaryButton>
    );

  const actions =
    variant === 'sidebar' ? (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '10px 12px 12px',
          borderBottom: panelColors ? `1px solid ${panelColors.border}` : '1px solid var(--border, #1E2634)',
          flexShrink: 0,
        }}
      >
        <PrimaryButton
          title="New Trade Journal"
          onClick={openJournal}
          variant="compact"
          size="sm"
          style={{
            width: '100%',
            height: 36,
            minHeight: 36,
            paddingTop: 0,
            paddingBottom: 0,
            fontSize: '0.875rem',
            justifyContent: 'center',
          }}
        >
          <PencilSquare size={16} />
          Journal
        </PrimaryButton>
        {rulesButton}
      </div>
    ) : (
      <>
        <PrimaryButton
          title="New Trade Journal"
          onClick={openJournal}
          variant="compact"
          size="sm"
          style={{ height: 32, minHeight: 32, paddingTop: 0, paddingBottom: 0, fontSize: '0.875rem' }}
        >
          <PencilSquare size={17} />
          Journal
        </PrimaryButton>
        {rulesButton}
      </>
    );

  return actions;
}
